import store from '@/store'

export function getValues(source, entities, prefix) {

  let values = {};

  for (let i = 0; i < entities.length; i++) {

    let entity = entities[i];
    let column = entities[i].column;

    if (!column) continue;

    let value = store.state[source][source][column];

    if ((RegExp('^' + prefix).test(column))) {

      let key = column.split(/_(.+)/);

      if (entity.type === 'string') {

        if (store.state[source][source][key[0]]) {
          values[column] = store.state[source][source][key[0]][key[1]] || '';
        } else {
          values[column] = '';
        }

      } else if (entity.type === 'integer') {

        if (store.state[source][source][key[0]]) {
          values[column] = parseInt(values[column] = store.state[source][source][key[0]][key[1]]) || null;
        } else {
          values[column] = entity.default;
        }

      } else if (entity.type === 'array') {

        if (!store.state[source][source][key[0]]) store.state[source][source][key[0]] = {};

        if (Array.isArray(store.state[source][source][key[0]][key[1]])) {
          values[column] = store.state[source][source][key[0]][key[1]].map(a => parseInt(a));
        } else {
          values[column] = [];
        }

      } else if (entity.type === 'boolean') {

        if (store.state[source][source][key[0]] && typeof store.state[source][source][key[0]][key[1]] === 'boolean') {
          values[column] = store.state[source][source][key[0]][key[1]];
        } else {
          values[column] = (entity.default === 'true');
        }
      }

    } else if (entity.type === 'integer') {

      values[column] = value || entity.default;

    } else if (entity.type === 'boolean') {

      if (typeof value === 'boolean') {
        values[column] = value;
      } else {
        values[column] = (entity.default === 'true');
      }

    } else {
      values[column] = value || '';
    }
  }

  return values;
}

export function prepareValues(values, prefix) {

  let prepared = {};

  for (let column in values) {

    if ((RegExp('^' + prefix).test(column))) {

      let key = column.split(/_(.+)/);

      if (typeof values[column] !== 'undefined') {
        // if (!prepared.hasOwnProperty(key[0])) prepared[key[0]] = {};
        if (!Object.prototype.hasOwnProperty.call(prepared, key[0])) prepared[key[0]] = {};
        prepared[key[0]][key[1]] = values[column] || '';
      } 

    } else {

      prepared[column] = values[column];
    }
  }
  return prepared;
}
